import secureLocalStorage from "react-secure-storage";

export const JWT_STORAGE_KEY = 'JWT_TOKEN';

export const getJwtToken = () => {
    return secureLocalStorage.getItem(JWT_STORAGE_KEY);
};

export const setJwtToken = (token: string) => secureLocalStorage.setItem(JWT_STORAGE_KEY, token);
